// extracted by mini-css-extract-plugin
export default {"page":"businesDashboard_page__1pjmV","createButton":"businesDashboard_createButton__8X4xo"};